import React from 'react';
import { Link } from 'react-router-dom';
import '../styling/ProductsSubpages.css';
import stab1 from '../styling/images/stabilizer/servo_motor_control/category1a.png';
import stab2 from '../styling/images/stabilizer/servo_motor_control/category1b.png';
import stab3 from '../styling/images/stabilizer/servo_motor_control/category1c.png';
import stab4 from '../styling/images/stabilizer/static/category2a.png';
import stab5 from '../styling/images/stabilizer/relay/category3a.png';

const Stabilizer = () => {
  const categories = [
    { 
      id: 1, 
      name: 'SERVO MOTOR CONTROL BASED AVR',
      images: [
        { id: 1, src: stab1, caption1: '1 Phase AVR', caption2: '0.5KVA to 30KVA' },
        { id: 2, src: stab2, caption1: '3 Phase AVR', caption2: '3KVA to 100KVA' },
        { id: 3, src: stab3, caption1: 'SBW/F 1 Phase & 3 Phase AVR', caption2: '30KVA to 1000KVA' }
      ]
    },{
      id: 2,
      name: 'STATIC TECHNOLOGY BASED AVR',
      images: [
        { id: 4, src: stab4, caption1: '1 Phase & 3 Phase Static AVR' }
      ]
    },{
      id: 3,
      name: 'RELAY CONTROL BASED AVR',
      images: [ 
        { id: 5, src: stab5, caption1: '1 Phase Relay AVR', caption2: '1KVA to 20KVA'}
      ]
    }
  ];

  const scrollToHeading = (headingId) => {
    const element = document.getElementById(headingId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className='container'>
      <nav className="side-nav">
        <ul>
          {categories.map(category => (
            <li key={category.id}>
              <button onClick={() => scrollToHeading(`heading-${category.id}`)}>{category.name}</button>
              <ul>
                {category.images.map(image => (
                  <li key={image.id}>
                    <Link to={`/product_items/Stabilizer_cat/StabilizerSubpages/${image.id}`}>
                      {image.caption1}  {image.caption2}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </nav>
      <div className="content">
        <h1>AUTOMATIC VOLTAGE STABILIZER</h1>
        {categories.map(category => (
          <div key={category.id} id={`heading-${category.id}`}>
            <h2>{category.name}</h2>
            <div className='row'>
              {category.images.map(image => (
                <div key={image.id} className='category-products'>
                  <Link to={`/product_items/Stabilizer_cat/StabilizerSubpages/${image.id}`}  state={{ productCategory: category.name, productCap1: image.caption1, productCap2: image.caption2}}>
                    <img src={image.src} alt={`Image ${image.id}`} className='category-images'/>
                  </Link>
                  <p>{image.caption1}<br/>{image.caption2}</p>
                </div> 
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Stabilizer;
 